export default __webpack_public_path__ + "static/media/VARGO.6e3c0732.png";